// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='60'
    height='60'
    viewBox='0 0 60 60'
    ...attributes
  ><g
      fill='none'
      stroke='var(--icon-color, #000)'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='3'
      opacity='.8'
      transform='translate(15 15)'
    ><rect width='30' height='30' rx='2' /><circle
        cx='8.5'
        cy='8.5'
        r='2.5'
      /><path d='m30 20-8.334-8.333L3.333 30' /></g></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'ImagePlaceholder';
export default IconComponent;
